/**
 * What a piece of hardware IS, at the coarse grain the catalog files by.
 *
 * A closed list, because the dashboard groups by it, the SKU prefix conventions
 * lean on it, and "future hardware" is a real category rather than an excuse to
 * leave the field open. A genuinely new kind of thing is a one-line addition
 * here (and the check constraint that mirrors it, migration by migration).
 */

export const HARDWARE_CATEGORIES = [
  'CASE',
  'TABLET',
  'SCANNER',
  'PRINTER',
  'CAMERA',
  'COMPUTE',
  'NETWORK',
  'POWER',
  'CABLE',
  'AUDIO',
  'VIDEO',
  'PAYMENT',
  'SCALE',
  'DISPLAY',
  'MOUNT',
  'ADAPTER',
  'CHARGER',
  'CONSUMABLE',
  'DOCUMENTATION',
  'PANEL',
  'OTHER',
] as const;
export type HardwareCategory = (typeof HARDWARE_CATEGORIES)[number];

/** The word a person reads in the catalog filter and the dashboard grouping. */
export const HARDWARE_CATEGORY_LABEL: Readonly<Record<HardwareCategory, string>> = {
  CASE: 'Case',
  TABLET: 'Tablet',
  SCANNER: 'Scanner',
  PRINTER: 'Printer',
  CAMERA: 'Camera',
  COMPUTE: 'Compute',
  NETWORK: 'Network',
  POWER: 'Power',
  CABLE: 'Cable',
  AUDIO: 'Audio',
  VIDEO: 'Video',
  PAYMENT: 'Payment',
  SCALE: 'Scale',
  DISPLAY: 'Display',
  MOUNT: 'Mount',
  ADAPTER: 'Adapter',
  CHARGER: 'Charger',
  CONSUMABLE: 'Consumable',
  DOCUMENTATION: 'Documentation',
  PANEL: 'Panel',
  OTHER: 'Other',
};

export function isHardwareCategory(v: unknown): v is HardwareCategory {
  return typeof v === 'string' && (HARDWARE_CATEGORIES as readonly string[]).includes(v);
}
